/**
 * outbox の永続化（純関数・node テスト可能）— Phase 2 / Slice 3
 * -----------------------------------------------------------------------------
 * 保留中の書込（drafts=作成/更新・deletes=削除・pendingCreates=未送信の新規行）を
 * IndexedDB へ保存し、起動時に復元する（ブラウザを閉じてもオフライン編集が残る）。
 * KV 本体は reference/core/idb-kv.mjs を流用（SSOT を複製しない）。ここは形の変換のみ。
 *
 * スナップショット形式（1 アプリ分）:
 *   { appId, drafts: {tableId:{rowId:Draft}}, pendingCreates: string[], deletes: {tableId:string[]} }
 *   - drafts の値 Draft = { values, base, baseVersion }（outbox.mjs と同形）。
 *   - pendingCreates はメモリ上 Set だが、永続時は配列（構造化複製の都合と可読性）。
 */

/** KV キー（アプリ単位で分離＝複数アプリ切替でキューが混ざらない）。 */
export function outboxKey(appId) {
  return `sheetsnap:outbox:${appId ?? ""}`;
}

/** メモリ上の状態 → 保存用スナップショット（Set は配列へ）。 */
export function serializeOutbox({ appId, drafts, pendingCreates, deletes }) {
  return {
    appId: appId ?? "",
    drafts: drafts ?? {},
    pendingCreates: [...(pendingCreates ?? [])],
    deletes: deletes ?? {},
  };
}

/** 保存スナップショット → メモリ上の状態（pendingCreates は Set へ復元）。 */
export function deserializeOutbox(snap) {
  if (!snap || typeof snap !== "object") {
    return { drafts: {}, pendingCreates: new Set(), deletes: {} };
  }
  return {
    drafts: snap.drafts ?? {},
    pendingCreates: new Set(Array.isArray(snap.pendingCreates) ? snap.pendingCreates : []),
    deletes: snap.deletes ?? {},
  };
}

/** 保留件数（作成/更新の行数＋削除の行数）。バッジ表示に使う。 */
export function countPending({ drafts, deletes } = {}) {
  let n = 0;
  for (const t of Object.keys(drafts ?? {})) n += Object.keys(drafts[t] ?? {}).length;
  for (const t of Object.keys(deletes ?? {})) n += (deletes[t] ?? []).length;
  return n;
}

/** 保留があるか。 */
export function hasPending(state) {
  return countPending(state) > 0;
}
